import FooterWave2Icon from "@/public/site-assets/svg/footer-wave-2.svg";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import clsx from "classnames";
import { useEffect, useRef, useState } from "react";
import { Container } from "reactstrap";
import Buttons from "ui/Buttons/component";
import styles from "./styles.module.scss";
import OverlayDots from "/public/site-assets/svg/overlay-dots.svg";
import StarIcon from "/public/site-assets/svg/star.svg";

export const ImageWithTextSlanted = ({
  className,
  heading,
  content,
  reverse,
  image,
  video_url,
  buttons,
  wrapper_bg,
  showWave,
  waveDirection,
  waveColor,
  waveBackground,
  showTopWave,
  topWaveDirection,
  topWaveColor,
  topWaveBackground,
}) => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [playVideo, setPlayVideo] = useState(false);

  useEffect(() => {
    Fancybox.bind("[data-fancybox]", {});

    Fancybox.bind("[data-fancybox]", {
      on: {
        close: () => {
          setPlayVideo(false);
        },
      },
    });
  }, []);

  useEffect(() => {
    if (playVideo) {
      document.querySelector("[data-fancybox]").click();
    }
  }, [playVideo]);

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
        .fancybox__container {
          --fancybox-bg: rgba(24, 24, 27, 0.5) !important;
        }
        .with-fancybox {
          --fancybox-scrollbar-compensate: 0 !important;
        }
      `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1, // Adjust threshold as needed, make it smaller for more sensitive detection
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      });
    }, options);

    observer.observe(sectionRef.current);

    // Cleanup function
    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobileDevice = window.innerWidth <= 991; // Adjust threshold for mobile devices
      // setIsVisible(!mobileDevice); // Hide motion on mobile devices
    };

    handleResize(); // Call initially
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      {showTopWave && (
        <div
          className={clsx(
            "footer",
            topWaveDirection === "down" && "rotate",
            topWaveColor,
            topWaveBackground,
          )}
          style={{ marginBottom: "-1px", zIndex: 1, position: "relative" }}
        >
          <FooterWave2Icon />
        </div>
      )}
      <section ref={sectionRef} className={clsx(className, styles.root, reverse && `flip-column`)}>
        <Container>
          <div className="position-relative">
            <>
              <span className="floating-icons">
                <StarIcon />
              </span>
              <span className="floating-icons">
                <StarIcon />
              </span>
              <span className="floating-icons">
                <StarIcon />
              </span>
            </>
            <div className={`wrapper align-items-center ${wrapper_bg}`}>
              <div className="position-relative left">
                <div className={"image"}>
                  {video_url ? (
                    <>
                      <div
                        onClick={() => setPlayVideo(true)}
                        className="bg-transparent border-0"
                        role="button"
                      >
                        <img
                          className={`featured-video position-relative z-index-1`}
                          src={image?.url}
                          alt={image?.alt}
                        />
                      </div>
                      <a data-fancybox href={video_url} className="play-button"></a>
                    </>
                  ) : (
                    <img
                      className={`image position-relative z-index-1`}
                      src={image?.url}
                      alt={image?.alt}
                    />
                  )}
                </div>

                <div className="overlay-dots position-absolute">
                  <OverlayDots />
                </div>
              </div>
              <div className="position-relative z-index-1">
                {heading && <h3 className="mb-3 mt-3">{heading}</h3>}
                {content && (
                  <div className={`content py-4`} dangerouslySetInnerHTML={{ __html: content }} />
                )}
                {buttons && (
                  <Buttons buttons={buttons} className="d-flex text-center button-position" />
                )}
              </div>
            </div>
          </div>
        </Container>
      </section>
      {showWave && (
        <div
          className={clsx(
            "footer",
            waveDirection === "down" && "rotate",
            waveColor,
            waveBackground,
          )}
          style={{ marginTop: "-1px" }}
        >
          <FooterWave2Icon />
        </div>
      )}
    </>
  );
};

export default ImageWithTextSlanted;
